<template>
  <v-app :class="{'mobile': $vuetify.breakpoint.smAndDown}">
    <side-menu v-model="drawer" />
    <top-menu v-model="drawer" />
    <snackbar />

    <v-content>
      <transition
        name="fade"
        mode="out-in">
        <router-view/>
      </transition>
      <login-modal />
    </v-content>
  </v-app>
</template>

<script>
import SideMenu from '@/components/layout/SideMenu.vue';
import LoginModal from '@/components/LoginModal.vue';
import TopMenu from '@/components/layout/TopMenu.vue';
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'App',
  data: () => ({
    drawer: false,
  }),
  mounted() {
    this.drawer = !this.$vuetify.breakpoint.smAndDown;
  },
  components: {
    LoginModal,
    SideMenu,
    TopMenu,
    Snackbar,
  },
};
</script>

<style lang="stylus">
.v-dialog
  > .v-card
    margin 0
.v-card
  > .v-toolbar:not(.simple)
    margin 14px 14px 0 14px!important
    top -14px
    width unset

.blurred
  filter blur(8px)
  transition filter .3s

.fade-enter-active
.fade-leave-active
  transition-duration 0.3s
  transition-property opacity
  transition-timing-function ease

.fade-enter
.fade-leave-active
  opacity 0

*::-webkit-scrollbar
  width 6px
*::-webkit-scrollbar-track
  background #ddd
*::-webkit-scrollbar-thumb
  background var(--v-accent-base)

table
  td
    position relative
  tr.clickable
    cursor pointer

.v-treeview-node--leaf
  height 48px
  cursor pointer
  &:hover
    background-color rgba(0,0,0,.04)

.overlay
  position absolute
  background-color rgba(0,0,0, 0.2)
  border-radius 2px
  z-index 1
  top 0
  left 0
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  flex-direction column

input[type="number"]::-webkit-outer-spin-button
input[type="number"]::-webkit-inner-spin-button
  -webkit-appearance none
  margin 0
input[type="number"]
  -moz-appearance textfield

.login-logo
  position absolute
  right 10px
  top 10px
  width 100px
  height 100px

.mobile
  .v-datatable__actions__select
    display none

.v-overlay
  z-index 4
.v-navigation-drawer
  z-index 5
.v-toolbar--fixed
  z-index 3

.v-navigation-drawer[data-booted=true]
  transition 500ms cubic-bezier(0.165, 0.84, 0.44, 1)

/* ANIMAZIONI */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(.17, .67, .83, .67);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 500ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.card-expand-icon
  position absolute
  top 5px
  right 5px

.v-dialog.v-bottom-sheet
  > .v-toolbar
    z-index 2

.chart-tooltip
  .v-list
    .v-list__tile__title
      white-space inherit
      text-overflow inherit
      overflow inherit
      height auto
</style>
